import { render, staticRenderFns } from "./CadastrarApoio.vue?vue&type=template&id=47082856"
import script from "./CadastrarApoio.vue?vue&type=script&lang=js"
export * from "./CadastrarApoio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports